import { compact, uniq } from 'lodash';

import { CommonAiSuggestionEvidenceFragment } from '@/modules/aiSuggestions/graphql/aiSuggestions.generated';
import { DocumentSearchResult } from '@/modules/pdf/DocumentSearch/DocumentSearch.types';

/** Converts file paragraphs into document annotations. */
function fileParagraphsAdapter(
  input: CommonAiSuggestionEvidenceFragment['fileParagraphs']
): DocumentSearchResult[] {
  const paragraphs = compact(input.edges?.map((edge) => edge?.node));
  return paragraphs.flatMap((paragraph) => {
    const documentId = paragraph.file?.pdfDocument?.id;
    if (!documentId) return [];

    return paragraph.boundingRegions.map((region) => ({
      documentID: documentId,
      PageNumber: region.PageNumber,
      Polygon: region.Polygon,
    }));
  });
}

/** Converts every evidence row's file paragraphs into document annotations. */
export function suggestionEvidenceAdapter(
  evidence: ReadonlyArray<CommonAiSuggestionEvidenceFragment> | null | undefined
): DocumentSearchResult[] {
  return (evidence ?? []).flatMap((item) =>
    fileParagraphsAdapter(item.fileParagraphs)
  );
}

/** Returns the unique documents referenced by suggestion evidence. */
export function getSuggestionEvidenceDocumentIds(
  evidence: ReadonlyArray<CommonAiSuggestionEvidenceFragment> | null | undefined
): string[] {
  return uniq(suggestionEvidenceAdapter(evidence).map((a) => a.documentID));
}
